import { REGEX_EMAIL, REGEX_PASSWORD } from "@/config/constants";
import _ from "lodash";
import { useState } from "react";
import { InputProfileTemplate } from "./template";

const InputProfile = ({ onPressLogin, onPressSignUp, loading }) => {
	const [errors, setErrors] = useState({});

	const validateForm = (values = {}) => {
		const { first_name, last_name, email, phone, password, confirm_password, address = {} } = values;

		const errs = {};
		const regrex = new RegExp(REGEX_PASSWORD);

		if (!first_name) errs.first_name = "Please enter your first name.";
		if (!last_name) errs.last_name = "Please enter your last name.";

		if (!email) errs.email = "Please enter your email.";
		else if (!REGEX_EMAIL.test(email)) errs.email = "Please enter a valid email address.";

		if (!phone || phone.length < 6) errs.phone = "Please enter a valid phone number.";

		if (!password) errs.password = "Please enter your password.";
		else if (!regrex.test(password)) {
			errs.password =
				"Password must contain at least 8 characters, at least one uppercase letter, one lowercase letter, one number and special character.";
		}

		if (!confirm_password) errs.confirm_password = "Please confirm your password.";
		else if (password !== confirm_password) errs.confirm_password = "Confirm password does not match";

		const addressErr = {};
		if (!address?.address) addressErr.address = "Please enter your address line 1.";
		if (!address?.country?.short_code) addressErr.country = "Please select your country.";
		if (!address?.city) addressErr.city = "Please enter your city.";
		// if (!address?.state) addressErr.state = "Please enter your state.";
		if (address?.country?.short_code === "US" && !address?.state) {
			addressErr.state = "Please enter your state.";
		}

		if (!_.isEmpty(addressErr)) errs.address = addressErr;

		const isValid = _.isEmpty(errs);
		setErrors(errs);
		return isValid;
	};

	const onSignUp = async (values) => {
		if (!validateForm(values)) return;
		onPressSignUp(values);
	};

	const initProps = {
		errors: errors,
		setErrors: setErrors,
		onPressLogin,
		onFinish: onSignUp,
		loading,
	};
	return <InputProfileTemplate {...initProps} />;
};

export default InputProfile;
